<template>
    <section class="login_section">
    <div class="div-block-1040"><img sizes="64.421875px" srcset="images/Logo-p-500.png 500w, images/Logo-p-800.png 800w, images/Main_Logo.png 1000w" alt="" src="images/Main_Logo.png" loading="lazy" class="image-167"></div>
    <div class="w-layout-blockcontainer container-12 w-container">
        <h1 class="heading-45">Reset password</h1>
        
        <div class="div-block-1041 logContain">
            <div class="w-form">
                <form @submit.prevent="onSubmit">
                    <p>Enter new password.</p>
                    <input class="text-field-35 w-input" maxlength="256" v-model="password" name="email-or-phone" data-name="Email Address" placeholder="Enter password" type="password" id="email-or-phone"  required>
                    <p>Re-enter password.</p>
                    <input class="text-field-35 w-input" maxlength="256" v-model="repete_password" name="email-or-phone" data-name="Email Address" placeholder="Repete password" type="password" id="email-or-phone" required>
                    <button class="submit-button-6 w-button" :disabled="submitted" style="padding-top:12px; color:#fff">
                        <div v-if="submitted">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="15px" height="15px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                                <circle cx="50" cy="50" fill="none" stroke="blue" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                                    <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.53475935828877s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                                </circle>
                            </svg>
                        </div>
                        <div v-else>
                            <div class="">Reset Password</div>
                        </div>
                    </button>

                    <div class="text-block-203">Forgot Password? <a href="/forgot-password" class="link-12">click here to reset <span class="text-span-163">-&gt;</span></a></div>
                </form>
                <div class="w-form-done" style="display:block;padding-top:5px; background-color: rgb(212, 239, 238);" v-if="success">
                    <div>Password changed successfully. Click Here to <router-link to="/login">Login</router-link>
                    </div>
                </div>
                <div class="w-form-fail" style="display:block;" v-if="err">
                    <div>Link expired!
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

</template>

 
<script>
export default {
    name: 'ResetPassword',
    props: ['baseUrl'],
    data() {
        return {
            password: '',
            repete_password:'',
            submitted: false,
            success: false,
            err:false,
            
        }
    },
    computed:{
        errorp(){
            if (this.password !== this.repete_password && this.repete_password !== '') {
             return  true;
            }
            return  false;
        }
    },
    methods: {
        onSubmit() {
            this.submitted = true;
            this.err = false;
            this.$axios.post(`${this.baseUrl}/api/password-reset`, {
                password: this.password,
                token: this.$route.params.token
            }).then(response => {
                if (response.data.status == 'success') {
                    this.success= true;
                    this.submitted = false;
                    this.$router.push('/login');
                } else {
                    this.submitted = false;
                    this.err = true;
                }
            });

        },
    },
}
</script>
<style scoped>
.login_section .w-layout-blockcontainer.container-12.w-container {
    max-width: 540px;
    padding: 0;
}
</style>